import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface Props {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmDeleteModal: React.FC<Props> = ({ show, onClose, onConfirm }) => {
  const { t } = useTranslation();
  return (
    <Modal
      show={show}
      onHide={onClose}
      className="modal--sm"
      style={{ opacity: 1 }}
    >
      <Modal.Header closeButton>
        <h4>{t("siteManagement.popup.delete.title")}</h4>
      </Modal.Header>
      <Modal.Body>
        <p className="text text--14">{t("siteManagement.popup.delete.info")}</p>
        {t("siteManagement.popup.delete.subInfo")
          .split("\n")
          .map((i, idx) => (
            <p className="text text--gray text--13" key={idx}>
              {i}
            </p>
          ))}
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn btn-gray" onClick={onClose}>
          {t("common.cancelBtn")}
        </Button>
        <Button className="btn btn-green" onClick={onConfirm}>
          {t("common.okBtn")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDeleteModal;
